import { and2Lazy, join2Lazy, some2lazy } from "./_rule-binary-ops";
import { rule } from "./rule";
import { skipEmptyMapper } from "./_helpers";
import prepareRule from "./_prepare-rule";

export { rule };

const makeRule = skipEmptyMapper(prepareRule);

/**
 * Builds new complex `ValidationRuleFn` from other `ValidationRuleFn`'s.
 *
 * New complex rule applies its subrules one by one until find error.
 *
 * @typedef {import("./types").ValidationRuleFn} ValidationRuleFn
 * @type {(...rules: ValidationRuleFn[]) => ValidationRuleFn}
 */
export const all = (...rules) => rules.map(makeRule).reduce(and2Lazy);

/**
 * Builds new complex `ValidationRuleFn` from other `ValidationRuleFn`'s.
 *
 * New complex rule applies all its subrules one by one and packs all found
 * errors to the array
 *
 * @typedef {import("./types").ValidationRuleFn} ValidationRuleFn
 * @type {(...rules: ValidationRuleFn[]) => ValidationRuleFn}
 */
export const join = (...rules) => rules.map(makeRule).reduce(join2Lazy);

export const some = (...rules) => rules.map(makeRule).reduce(some2lazy);
